import authService from "@/services/auth";
import router from "@/router";
export default {
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    logout() {
      localStorage.removeItem("user");
      router.push({
        name: "Login"
      });
    },
    async login({ commit }, payload) {
        let user = await authService.login(payload);
        localStorage.setItem("user", JSON.stringify(user.data));
        commit("setUser", user.data);
        return user;
    }
  }
};
